export const defaultTimerState = {
  initialized: false,
  currentTime: '00:00:00 A',
  sessionTime: '00:00:00',
  gameTime: '00:00:00',
  serverTimeValue: undefined as number | undefined,
  sessionStartValue: undefined as number | undefined,
  gameStartValue: undefined as number | undefined,
};

export type TimerSlice = typeof defaultTimerState & {
  setCurrentTime: (time: string) => void;
  setSessionTime: (time: string) => void;
  setGameTime: (time: string) => void;
  setServerTimeValue: (time: number) => void;
  setSessionStartValue: (time: number) => void;
  setGameStartValue: (time: number) => void;
  resetGameTime: () => void;
};
